module.exports = __webpack_public_path__ + "img/cosmos1.1eeda03c.jpg";